<script>
import {
  pageCommanderConfirmationErrorProps,
  usePageCommanderConfirmationError
} from "./mixin";

import OrderError from "@/components/organisms/order-confirmation/order-error";
export default {
  components: {
    OrderError
  },
  props: {
    ...pageCommanderConfirmationErrorProps()
  },
  setup() {
    const { created, setPopinPanierToListe, typePanier } =
      usePageCommanderConfirmationError();

    created();

    return { setPopinPanierToListe, typePanier };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <OrderError
      :statut="statut"
      :type-panier="typePanier"
      @setPopinPanierToListe="setPopinPanierToListe"
    />
  </div>
</template>
